angular.module('GeoDataExportApp').factory('GeoDataExportResource', function($resource) {
    var url = '/api/v2.0/khutils/geodataexport/';
    return $resource(url, {}, {
        get: {
            params: {team_slug: '@team', farm_slug: '@farm', field_slug: '@field'},
            url: url
        }
    });
});
